// This mainly format date Iso String to 'MMMM D YYYY'
// e.g: "2021-02-25T13:44:08" => "Feb 25 2021"
export const formatIsoStringDate = (dateStr, withTime = false, numberOfHoursToAdd) => {
  const date = new Date(dateStr);
  if (numberOfHoursToAdd) {
    date.setHours(date.getHours() + numberOfHoursToAdd);
  }
  const monthName = date.toLocaleString('default', {
    month: 'short',
  });
  const time = withTime
    ? date.toLocaleTimeString('default', { hour: '2-digit', minute: '2-digit' })
    : '';
  const formatedDate = `${monthName} ${date.getDate().toString()}, ${date
    .getFullYear()
    .toString()}${time && ` . ${time.toString()}`}`;
  return formatedDate;
};
